// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.am-page {
  width: 100%;
  color: #26354a;
  font-family: 'Malgun Gothic', Arial, sans-serif;
  box-sizing: border-box;
}

.am-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}

.am-heading h2 {
  font-size: 21px;
  margin: 0 0 6px;
}

.am-heading p {
  margin: 0;
  color: #8190a2;
  font-size: 13px;
}

.am-total {
  font-size: 13px;
  background: #eaf3ff;
  color: #1671d8;
  padding: 9px 13px;
  border-radius: 7px;
  font-weight: 700;
}

.am-panel {
  background: #fff;
  border-radius: 10px;
  padding: 22px;
  box-shadow: 0 2px 9px #1e375a10;
}

.am-search {
  display: flex;
  gap: 10px;
}

.am-search input {
  flex: 1 1;
  min-width: 0;
  height: 41px;
  border: 1px solid #d9e0e9;
  border-radius: 5px;
  background: #fff;
  padding: 0 12px;
  color: #34465b;
  font-size: 13px;
}

.am-search input:focus {
  outline: 2px solid #90c7ff;
  outline-offset: 1px;
}

.am-search button,
.am-pagination button {
  border: 1px solid #d9e0e9;
  background: #fff;
  color: #34465b;
  border-radius: 5px;
  padding: 8px 16px;
  cursor: pointer;
}

.am-search button:hover,
.am-pagination button:hover:not(:disabled) {
  background: #edf5ff;
}

.am-table-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin: 25px 0 12px;
  font-size: 14px;
}

.am-table-top span {
  font-size: 12px;
  color: #8a98a8;
}

.am-table-wrap {
  width: 100%;
  overflow-x: auto;
}

.am-table {
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;
  font-size: 12px;
  text-align: center;
}

.am-table th {
  background: #f1f5fa;
  color: #3b4c62;
  border-top: 2px solid #2196f3;
  padding: 14px 9px;
  white-space: nowrap;
}

.am-table td {
  padding: 13px 9px;
  border-bottom: 1px solid #e8edf3;
}

.am-table tbody tr {
  cursor: pointer;
}

.am-table tbody tr:hover,
.am-table tbody tr:focus {
  background: #f1f8ff;
  outline: none;
}

.am-name {
  font-weight: 700;
}

.am-empty {
  text-align: center;
  padding: 45px !important;
  color: #8a98a8;
}

.am-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  color: #8090a1;
  font-size: 12px;
  gap: 10px;
}

.am-pagination {
  display: flex;
  align-items: center;
  gap: 5px;
}

.am-pagination button {
  padding: 7px 10px;
}

.am-pagination button.am-current {
  background: #168ff0;
  color: #fff;
  border-color: #168ff0;
}

.am-pagination button:disabled {
  opacity: .35;
  cursor: not-allowed;
}

.am-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 22px;
}

.am-actions button {
  padding: 10px 18px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.am-secondary {
  background: #fff;
  border: 1px solid #d9e0e9;
  color: #34465b;
}

.am-primary {
  background: #168ff0;
  border: 1px solid #168ff0;
  color: #fff;
}

.am-primary:hover {
  background: #087bd4;
}

.admin-management-layout .admin-management-content {
  flex: 1 1;
  min-width: 0;
  padding: 20px 28px 24px;
  box-sizing: border-box;
}

@media (max-width: 900px) {
  .am-panel {
    padding: 15px;
  }

  .admin-management-layout .admin-management-content {
    padding: 15px;
  }
}

@media (max-width: 560px) {
  .am-search {
    flex-wrap: wrap;
  }

  .am-search input {
    flex-basis: 100%;
  }

  .am-bottom {
    flex-direction: column;
  }

  .am-table-top span {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/AdminManagementRedesign.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".am-page {\n  width: 100%;\n  color: #26354a;\n  font-family: 'Malgun Gothic', Arial, sans-serif;\n  box-sizing: border-box;\n}\n\n.am-heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 18px;\n}\n\n.am-heading h2 {\n  font-size: 21px;\n  margin: 0 0 6px;\n}\n\n.am-heading p {\n  margin: 0;\n  color: #8190a2;\n  font-size: 13px;\n}\n\n.am-total {\n  font-size: 13px;\n  background: #eaf3ff;\n  color: #1671d8;\n  padding: 9px 13px;\n  border-radius: 7px;\n  font-weight: 700;\n}\n\n.am-panel {\n  background: #fff;\n  border-radius: 10px;\n  padding: 22px;\n  box-shadow: 0 2px 9px #1e375a10;\n}\n\n.am-search {\n  display: flex;\n  gap: 10px;\n}\n\n.am-search input {\n  flex: 1;\n  min-width: 0;\n  height: 41px;\n  border: 1px solid #d9e0e9;\n  border-radius: 5px;\n  background: #fff;\n  padding: 0 12px;\n  color: #34465b;\n  font-size: 13px;\n}\n\n.am-search input:focus {\n  outline: 2px solid #90c7ff;\n  outline-offset: 1px;\n}\n\n.am-search button,\n.am-pagination button {\n  border: 1px solid #d9e0e9;\n  background: #fff;\n  color: #34465b;\n  border-radius: 5px;\n  padding: 8px 16px;\n  cursor: pointer;\n}\n\n.am-search button:hover,\n.am-pagination button:hover:not(:disabled) {\n  background: #edf5ff;\n}\n\n.am-table-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  margin: 25px 0 12px;\n  font-size: 14px;\n}\n\n.am-table-top span {\n  font-size: 12px;\n  color: #8a98a8;\n}\n\n.am-table-wrap {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.am-table {\n  width: 100%;\n  min-width: 900px;\n  border-collapse: collapse;\n  font-size: 12px;\n  text-align: center;\n}\n\n.am-table th {\n  background: #f1f5fa;\n  color: #3b4c62;\n  border-top: 2px solid #2196f3;\n  padding: 14px 9px;\n  white-space: nowrap;\n}\n\n.am-table td {\n  padding: 13px 9px;\n  border-bottom: 1px solid #e8edf3;\n}\n\n.am-table tbody tr {\n  cursor: pointer;\n}\n\n.am-table tbody tr:hover,\n.am-table tbody tr:focus {\n  background: #f1f8ff;\n  outline: none;\n}\n\n.am-name {\n  font-weight: 700;\n}\n\n.am-empty {\n  text-align: center;\n  padding: 45px !important;\n  color: #8a98a8;\n}\n\n.am-bottom {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 20px;\n  color: #8090a1;\n  font-size: 12px;\n  gap: 10px;\n}\n\n.am-pagination {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.am-pagination button {\n  padding: 7px 10px;\n}\n\n.am-pagination button.am-current {\n  background: #168ff0;\n  color: #fff;\n  border-color: #168ff0;\n}\n\n.am-pagination button:disabled {\n  opacity: .35;\n  cursor: not-allowed;\n}\n\n.am-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 22px;\n}\n\n.am-actions button {\n  padding: 10px 18px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.am-secondary {\n  background: #fff;\n  border: 1px solid #d9e0e9;\n  color: #34465b;\n}\n\n.am-primary {\n  background: #168ff0;\n  border: 1px solid #168ff0;\n  color: #fff;\n}\n\n.am-primary:hover {\n  background: #087bd4;\n}\n\n.admin-management-layout .admin-management-content {\n  flex: 1;\n  min-width: 0;\n  padding: 20px 28px 24px;\n  box-sizing: border-box;\n}\n\n@media (max-width: 900px) {\n  .am-panel {\n    padding: 15px;\n  }\n\n  .admin-management-layout .admin-management-content {\n    padding: 15px;\n  }\n}\n\n@media (max-width: 560px) {\n  .am-search {\n    flex-wrap: wrap;\n  }\n\n  .am-search input {\n    flex-basis: 100%;\n  }\n\n  .am-bottom {\n    flex-direction: column;\n  }\n\n  .am-table-top span {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
